import { GeoCoordinates } from '@fmnts/api';

// Datetime expressed using ISO-8601 (e.g. 2020-03-30T07:28:06+00:00)
type Timestamp = string;

// String, containing only lowercase letters, numbers, underscores or hyphens
// Regex: /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/
type Slug = string;

export enum EventType {
  /**
   * Describes an event that is triggered automatically
   * e.g. via a timeout
   */
  Automatic = 'automatic',
  Click = 'click',
  Scroll = 'scroll',
}
export interface ApiEventLocation {
  // The current URL
  current: string;
  // Where the user came from within our app. Related to HTTP referer (sic!)
  referrer: string | null;
}

export interface ApiEventContext {
  // The tag name which corresponds to the event
  tag_name: string | null;

  // Optional id related to the event target
  target_id: string | null;

  // Optional id related to the event source
  source_id: string | null;
  // Category related to the event source
  source_category: string;
}
export interface ApiAnalyticsEvent {
  // Timestamp of the event
  timestamp: Timestamp;
  // Identifier for the user (fundraiser id)
  fundraiser: number | null;

  // Name of the event
  // Maximum length: 50
  name: Slug;

  // The type of event
  event_type: EventType;
  // Event specific context
  event_context: ApiEventContext;
  // Location information
  browser_location: ApiEventLocation;
  // Device coordinates
  device_coordinates: GeoCoordinates | null;
}

export type ApiAnalyticsClickEventContext = ApiEventContext;
export interface ApiAnalyticsClickEvent extends ApiAnalyticsEvent {
  event_type: EventType.Click;
  event_context: ApiAnalyticsClickEventContext;
}
